import { Space as AntSpace } from 'antd'
import type { SpaceProps } from 'antd'

// Wrapper Space: bọc AntD Space để features/pages không import trực tiếp 'antd'
// (hard-rule module-authoring #1). Pass-through, không thêm hành vi.
export default function UiSpace(props: SpaceProps) {
  return <AntSpace {...props} />
}

UiSpace.Compact = AntSpace.Compact
